<template>
    <v-card class="SharedFilesCard" elevation="5">
        <v-layout v-if="!user" align-center justify-start wrap>
            <v-flex md6 style="border-right: 1px solid lightgray">
                <div v-if="status=='pending'" >
                    <v-form v-model="form_valid" >

                        <connect-external-new
                                @update_email="update_email"
                                @update_username="update_username"
                                @update_cost="update_cost"
                                :emails="emails"
                                :email="email"
                                :user="$user"
                                :permissionDownload="permissionViewDownload"
                                :GivePermissionsView="GivePermissionsView"
                                :GivePermissionsDownload="GivePermissionsDownload"
                                :temporalPermissions="temporalPermissions"
                                :message="message"
                                ref="gdrivefiles">
                        </connect-external-new>
                       <upload-button v-model="files" v-if="ipfs"></upload-button>

                        <div v-if="missing_files && selected_files == 0" class="v-messages theme--light error--text">
                            <div class="v-messages__wrapper">
                                <div class="v-messages__message">{{$t('Select at least 1 file')}}</div>
                            </div>
                        </div>

                        <v-divider></v-divider>

                        <multiple-email-select v-model="emails" :user="$user" class="padding">

                        </multiple-email-select>

                        <div v-if="missing_emails && emails.length == 0" class="v-messages theme--light error--text">
                            <div class="v-messages__wrapper">
                                <div class="v-messages__message">{{$t('Select at least 1 email')}}</div>
                            </div>
                        </div>

                        <v-text-field v-if="!$user" class="padding mb-3"
                            v-model="email"
                            :label="$t('Your email')"
                            :rules="[rules.empty]"
                            required
                        ></v-text-field>

                        <div v-if="invalid_email && !valid_email(email)" class="v-messages theme--light error--text">
                            <div class="v-messages__wrapper">
                                <div class="v-messages__message">{{$t('Invalid email')}}</div>
                            </div>
                        </div>

                        <v-text-field class="padding"
                            v-model="message"
                            :label="$t('Message')"
                        ></v-text-field>

                        <v-flex xs12 class="padding checkboxes">
                            <v-layout row wrap>
                                <p aria-hidden="true" class="v-label v-label--active theme--light pt-1 pr-4" style="text-align: left">{{$t('Give permission to')}}</p>
                                <v-switch v-model="permissionViewDownload" color="primary" class="padding" style="margin:0" :label="label_permission"></v-switch>
                            </v-layout>
                        </v-flex>
                        <div v-if="invalid_permissions && !valid_permissions()" class="v-messages theme--light error--text">
                            <div class="v-messages__wrapper">
                                <div class="v-messages__message">{{$t('Invalid permissions')}}</div>
                            </div>
                        </div>

                        <v-switch v-model="limits" color="primary" class="padding" style="margin:0" :label="label_limits"></v-switch>
                        <temporal-permissions v-if="limits" ref="temporal" v-model="temporalPermissions" class="padding">

                        </temporal-permissions>

                        <v-flex xs12 class="padding checkboxes">
                            <v-layout row wrap>
                                <v-checkbox v-model="GivePermissionsView" color="primary" :label="$t('Allow re-sharing')"></v-checkbox>
                                <v-switch :disabled="!permissionViewDownload" v-if="GivePermissionsView" v-model="GivePermissionsDownload" color="primary" class="padding pt-1" style="margin:0" :label="label_permission_share"></v-switch>
                            </v-layout>
                        </v-flex>
                        <div v-if="invalid_give_permissions" class="v-messages theme--light error--text">
                            <div class="v-messages__wrapper">
                                <div class="v-messages__message">{{$t("You cannot allow the user to concede a permission that doesn't have.")}}</div>
                            </div>
                        </div>

                        <v-flex xs12 class="padding">
                            <v-checkbox v-model="accept" color="primary" :rules="[v => (v) || $t('You must accept the T&C to use our service')]" @change="accepted">
                                <span slot="label">
                                    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                                        <template v-slot:activator="{ on }">
                                              I accept the <span v-on="on" style="text-decoration: underline">terms and conditions</span>
                                        </template>
                                        <v-card>
                                          <v-toolbar dark color="primary">
                                            <v-btn icon dark @click="dialog=false">
                                              <v-icon>close</v-icon>
                                            </v-btn>
                                          </v-toolbar>
                                          <Terms></Terms>
                                        </v-card>
                                    </v-dialog>
                                </span>
                            </v-checkbox>

                        </v-flex>
                        <v-divider></v-divider>
                        <span style="display:none;">
                            <vue-recaptcha ref="recaptcha" class="vue-recaptcha" @verify="verifyCapcha" @expired="expireCapcha" badge="inline" sitekey="6LfwS5kUAAAAANg54YQfzRpWDgN6fSlYdxmZILbt" size="invisible"></vue-recaptcha>
                        </span>
                    </v-form>

                    <v-layout row style="height:50px;">
                          <v-flex xs12>
                              <div class="text-center">
                                  <v-btn round center :loading="loading" :disabled="!send_enabled" color="primary" class="white--text" style="margin-bottom: 0; margin-top: 6px" @click="testCapcha">{{$t('Send')}}
                                  <v-icon right dark>cloud_upload</v-icon>
                                  </v-btn>
                                  <span v-if="$user" style="position: relative; top: 5px; color:#A22C32;">{{cost}} <font-awesome-icon color="primary" icon="coins" class="stamina-icon"/></span>
                               </div>

                          </v-flex>
                    </v-layout>
                </div>
                <div v-else-if="status=='ok'" class="text-center">
                    <v-img
                            src="https://static1.squarespace.com/static/5785112415d5db7cc123a214/5789372737c5819281d09e69/5a8c1f01e2c483ba7d016766/1530702388704/success.jpg"
                            aspect-ratio="2.75"
                    ></v-img>
                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline mb-0">{{$t("You're done!")}}</h3>
                            <div>{{$t("Your request has been received and will be processed shortly. You will receive an email when the file has been shared (check the spam folder).")}}</div>
                        </div>
                    </v-card-title>
                    <v-layout row>
                        <v-flex xs12>
                            <div class="text-center pb-3">
                                <v-btn round center color="primary" dark @click="clear">{{$t("Send Another?")}}</v-btn>
                                <v-btn round center color="primary" dark @click="goRates">{{$t("Enterprise")}}</v-btn>
                                <v-btn v-if="!$user" round center color="primary" dark @click="goRegister">{{$t("Register")}}</v-btn>
                            </div>
                        </v-flex>
                    </v-layout>
                </div>
                <div v-else-if="status=='error'" class="errors-box">
                    <v-card-title primary-title>
                        <div>
                            <h3 v-if="errorTitle" class="headline mb-0">{{errorTitle}}</h3>
                            <h3 v-else class="headline mb-0">{{$t("Oops! Something went wrong :(")}}</h3>
                        </div>

                        <p v-if="errorDescription" style="margin-top: 16px;">{{errorDescription}}</p>

                        <v-expansion-panel v-else inset style="margin-top: 10px;">
                            <v-expansion-panel-content hide-actions>
                                <template v-slot:header>
                                    <div>
                                        <v-btn depressed small>{{$t("See detailed errors")}}</v-btn>
                                    </div>
                                </template>
                                <ul id="example-1" style="margin-left: 10px">
                                    <li v-for="error in errors">
                                        {{ error.message }}
                                    </li>
                                </ul>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                    </v-card-title>
                    <v-layout row>
                        <v-flex xs12>
                            <div class="text-center pb-2">
                                <v-btn round center color="primary" dark @click="tryAgain">{{$t("Try again")}}</v-btn>
                                <v-btn v-if="loginButton" round center color="primary" dark @click="goLogin">{{$t("Login")}}</v-btn>
                            </div>
                        </v-flex>
                    </v-layout>
                </div>
            </v-flex>
            <v-flex md6>
                <help-panel></help-panel>
            </v-flex>
        </v-layout>
        <div v-if="user">
            <div v-if="status=='pending'" >
                <v-form v-model="form_valid" >

                    <connect-external-new
                            @update_email="update_email"
                            @update_username="update_username"
                            @update_cost="update_cost"
                            :emails="emails"
                            :email="email"
                            :user="$user"
                            :permissionDownload="permissionViewDownload"
                            :GivePermissionsView="GivePermissionsView"
                            :GivePermissionsDownload="GivePermissionsDownload"
                            :temporalPermissions="temporalPermissions"
                            :message="message"
                            ref="gdrivefiles">
                    </connect-external-new>

                    <upload-files v-model="files" v-if="ipfs"></upload-files>

                    <div v-if="missing_files && selected_files == 0" class="v-messages theme--light error--text">
                        <div class="v-messages__wrapper">
                            <div class="v-messages__message">{{$t('Select at least 1 file')}}</div>
                        </div>
                    </div>

                    <v-divider></v-divider>

                    <multiple-email-select v-model="emails" :user="$user" class="padding">

                    </multiple-email-select>

                    <div v-if="missing_emails && emails.length == 0" class="v-messages theme--light error--text">
                        <div class="v-messages__wrapper">
                            <div class="v-messages__message">{{$t('Select at least 1 email')}}</div>
                        </div>
                    </div>

                    <v-text-field v-if="!$user" class="padding mb-3"
                                  v-model="email"
                                  :label="$t('Your email')"
                                  :rules="[rules.empty]"
                                  required
                    ></v-text-field>

                    <div v-if="invalid_email && !valid_email(email)" class="v-messages theme--light error--text">
                        <div class="v-messages__wrapper">
                            <div class="v-messages__message">{{$t('Invalid email')}}</div>
                        </div>
                    </div>

                    <v-text-field class="padding"
                                  v-model="message"
                                  :label="$t('Message')"
                    ></v-text-field>

                    <v-flex xs12 class="padding checkboxes">
                        <v-layout row wrap>
                            <p aria-hidden="true" class="v-label v-label--active theme--light pt-1 pr-4" style="text-align: left">{{$t('Give permission to')}}</p>
                            <v-switch v-model="permissionViewDownload" color="primary" class="padding" style="margin:0" :label="label_permission"></v-switch>
                        </v-layout>
                    </v-flex>
                    <div v-if="invalid_permissions && !valid_permissions()" class="v-messages theme--light error--text">
                        <div class="v-messages__wrapper">
                            <div class="v-messages__message">{{$t('Invalid permissions')}}</div>
                        </div>
                    </div>

                    <v-switch v-model="limits" color="primary" class="padding" style="margin:0" :label="label_limits"></v-switch>
                    <temporal-permissions v-if="limits" ref="temporal" v-model="temporalPermissions" class="padding">

                    </temporal-permissions>

                    <v-flex xs12 class="padding checkboxes">
                        <v-layout row wrap>
                            <v-checkbox v-model="GivePermissionsView" color="primary" :label="$t('Allow re-sharing')"></v-checkbox>
                            <v-switch :disabled="!permissionViewDownload" v-if="GivePermissionsView" v-model="GivePermissionsDownload" color="primary" class="padding pt-1" style="margin:0" :label="label_permission_share"></v-switch>
                        </v-layout>
                    </v-flex>
                    <div v-if="invalid_give_permissions" class="v-messages theme--light error--text">
                        <div class="v-messages__wrapper">
                            <div class="v-messages__message">{{$t("You cannot allow the user to concede a permission that doesn't have.")}}</div>
                        </div>
                    </div>

                    <v-flex xs12 class="padding">
                        <v-checkbox v-model="accept" color="primary" :rules="[v => (v) || $t('You must accept the T&C to use our service')]" @change="accepted">
                            <span slot="label">
                                <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                                    <template v-slot:activator="{ on }">
                                          I accept the <span v-on="on" style="text-decoration: underline">terms and conditions</span>
                                    </template>
                                    <v-card>
                                      <v-toolbar dark color="primary">
                                        <v-btn icon dark @click="dialog=false">
                                          <v-icon>close</v-icon>
                                        </v-btn>
                                      </v-toolbar>
                                      <Terms></Terms>
                                    </v-card>
                                </v-dialog>
                            </span>
                        </v-checkbox>
                    </v-flex>

                    <v-divider></v-divider>
                    <span style="display:none;">
                        <vue-recaptcha ref="recaptcha" class="vue-recaptcha" @verify="verifyCapcha" @expired="expireCapcha" badge="inline" sitekey="6LfwS5kUAAAAANg54YQfzRpWDgN6fSlYdxmZILbt" size="invisible"></vue-recaptcha>
                    </span>
                </v-form>

                <v-layout row style="height:50px;">
                    <v-flex xs12>
                        <div class="text-center">
                            <v-btn round center :loading="loading" :disabled="!send_enabled" color="primary" class="white--text" style="margin-bottom: 0; margin-top: 6px" @click="testCapcha">{{$t('Send')}}
                                <v-icon right dark>cloud_upload</v-icon>
                            </v-btn>
                            <span v-if="$user" style="position: relative; top: 5px;color:#A22C32;">{{cost}} <font-awesome-icon color="primary" icon="coins" class="stamina-icon"/></span>
                        </div>

                    </v-flex>
                </v-layout>
            </div>
            <div v-else-if="status=='ok'" class="text-center">
                <v-img
                        src="https://static1.squarespace.com/static/5785112415d5db7cc123a214/5789372737c5819281d09e69/5a8c1f01e2c483ba7d016766/1530702388704/success.jpg"
                        aspect-ratio="2.75"
                ></v-img>
                <v-card-title primary-title>
                    <div>
                        <h3 class="headline mb-0">{{$t("You're done!")}}</h3>
                        <div>{{$t("Your request has been received and will be processed shortly. You will receive an email when the file has been shared (check the spam folder).")}}</div>
                    </div>
                </v-card-title>
                <v-layout row>
                    <v-flex xs12>
                        <div class="text-center pb-3">
                            <v-btn round center color="primary" dark @click="clear">{{$t("Send Another?")}}</v-btn>
                            <v-btn round center color="primary" dark @click="goRates">{{$t("Enterprise")}}</v-btn>
                            <v-btn v-if="!$user" round center color="primary" dark @click="goRegister">{{$t("Register")}}</v-btn>
                        </div>
                    </v-flex>
                </v-layout>
            </div>
            <div v-else-if="status=='error'" class="errors-box">
                <v-card-title primary-title>
                    <div>
                        <h3 v-if="errorTitle" class="headline mb-0">{{errorTitle}}</h3>
                        <h3 v-else class="headline mb-0">{{$t("Oops! Something went wrong :(")}}</h3>
                    </div>

                    <p v-if="errorDescription" style="margin-top: 16px;">{{errorDescription}}</p>

                    <v-expansion-panel v-else inset style="margin-top: 10px;">
                        <v-expansion-panel-content hide-actions>
                            <template v-slot:header>
                                <div>
                                    <v-btn depressed small>{{$t("See detailed errors")}}</v-btn>
                                </div>
                            </template>
                            <ul id="example-1" style="margin-left: 10px">
                                <li v-for="error in errors">
                                    {{ error.message }}
                                </li>
                            </ul>
                        </v-expansion-panel-content>
                    </v-expansion-panel>

                </v-card-title>
                <v-layout row>
                    <v-flex xs12>
                        <div class="text-center pb-2">
                            <v-btn round center color="primary" dark @click="tryAgain">{{$t("Try again")}}</v-btn>
                            <v-btn v-if="loginButton" round center color="primary" dark @click="goLogin">{{$t("Login")}}</v-btn>
                        </div>
                    </v-flex>
                </v-layout>
            </div>
        </div>
    </v-card>
</template>

<style lang="scss">
    .errors-box {
        .v-expansion-panel__header {
            padding: 0;
        }
        .v-expansion-panel__container,
        .v-expansion-panel__container--active {
            max-width: 100%!important;
        }
        .v-expansion-panel__container--active {
            box-shadow: none!important;
            margin: 0!important;
        }
    }
</style>

<script>
    import FilesRepository from '@/repositories/FilesRepository'
    import LocalRepository from '@/repositories/LocalRepository'
    import MultipleEmailSelect from '@/components/SharedFilesCard/MultipleEmailSelect'
    import UploadFiles from '@/components/SharedFilesCard/UploadFiles'
    import TemporalPermissions from '@/components/SharedFilesCard/TemporalPermissions'
    import Terms from '@/components/Terms'
    import VueRecaptcha from 'vue-recaptcha';
    import ConnectExternalNew from "./ConnectExternalNew";
    import {VCardText, VExpansionPanel, VExpansionPanelContent, VCard,VBtn,VCheckbox,VSwitch,VIcon,VDialog,VToolbar,VForm,VTextField,VFlex,VLayout,VDivider,VCombobox,VImg,VCardActions,VCardTitle} from 'vuetify/lib'
    import config from "../../config"
    import HelpPanel from "../HelpPanel";
    import UploadButton from "components/SharedFilesCard/UploadButton";

    export default {
        components: {
            HelpPanel,
          UploadButton,
            VCardText,VExpansionPanel, VExpansionPanelContent, MultipleEmailSelect,ConnectExternalNew,VDialog,VToolbar,VCard,VSwitch,VCheckbox,VBtn,VIcon,VForm,VTextField,VFlex,VDivider,VCombobox,VLayout,VImg,VCardActions,VCardTitle,UploadFiles,TemporalPermissions,VueRecaptcha,Terms},
        props:['user'],
        data () {
            return {
                dialog: false,
                GivePermissionsView:false,
                GivePermissionsDownload:false,
                files:[],
                emails:[],
                temporalPermissions:null,
                loading:false,
                message:'',
                email:'',
                status:'pending',
                errors:null,
                loginButton: false,
                errorTitle: "",
                capchaReturn:"",
                capcha:config.capcha,
                missing_files: false,
                missing_emails: false,
                invalid_email: false,
                invalid_permissions: false,
                invalid_give_permissions: false,
                permissionViewDownload: false,
                limits:true,
                ipfs:false,
                form_valid: true,
                user_name: "",
                accept:false,
                cost:0,
                rules:{
                    empty: value => {
                        return (value.length!=0) || 'Email is required'
                    }
                },
            }
        },
        computed:{
            selected_files:function() {
                var n = this.files.length;
                var selfiles = this.$refs.gdrivefiles ? this.$refs.gdrivefiles.getSelectedFiles() : false;
                if (selfiles) n += selfiles.length;
                return n;
            },
            label_limits:function() {
                if (this.limits) return this.$t('Limited accesses (only one allowed)');
                return this.$t('Limited accesses');
            },
            label_permission:function() {
                if (this.permissionViewDownload) return this.$t('View and download')
                return this.$t('View')
            },
            label_permission_share:function() {
                if (this.GivePermissionsDownload) return this.$t('View and download')
                return this.$t('View')
            },
            valid_send:function() {
                if (this.selected_files == 0) {
                    this.missing_files = true;
                    console.log("Missing files");
                    return false;
                }
                if (this.emails.length == 0) {
                    this.missing_emails = true;
                    console.log("Missing emails");
                    return false;
                }
                if (!this.valid_email(this.email)) {
                    this.invalid_email = true;
                    console.log("Invalid email");
                    return false;
                }
                if (!this.valid_permissions()) {
                    this.invalid_permissions = true;
                    console.log("Invalid permissions");
                    return false;
                }

                if (!this.valid_give_permissions()) {
                    this.invalid_give_permissions = true;
                    return false;
                }else{
                    this.invalid_give_permissions = false;
                }

                //console.log("Valid");
                return true;
            },
            send_enabled:function() {
                return !this.loading && this.form_valid;
            }
        },
        watch: {
            files: function () {
                this.update_cost(0);
            },
            email: function() {
                //console.log("UEM:"+this.email);
            },
            permissionViewDownload: function() {
                if (!this.permissionViewDownload && this.GivePermissionsDownload) {
                    this.GivePermissionsDownload = false;
                }
            }
        },
        created() {
            //console.log("Created");
            if (this.$user) {
                this.email = this.$user.email;
            }
            this.ipfs = config.ipfs;
            this.$root.$on('clear-upload-form', (data) => {
                this.status = 'pending';
                this.clear();
                this.email=data.email;
            });
            this.loadFormData();
            if (LocalRepository.has('accepted') && LocalRepository.get("accepted")) {
                this.accept = true;
            }
            //console.log("EM:"+this.email);
        },
        methods:{
            valid_email:function(mail) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(mail).toLowerCase());
            },
            valid_permissions:function() {
                return true;
            },
            valid_give_permissions: function() {
                if(this.GivePermissionsDownload){
                    if(!this.permissionViewDownload){
                        return false;
                    }
                }

                return true;
            },
            update_email(val) {
                this.email = val
            },
            update_username(val) {
                this.user_name = val
            },
            update_cost(val) {
                this.cost = 0;
                let n_gfiles = val;
                if (this.$refs.gdrivefiles && this.$refs.gdrivefiles.getSelectedFiles()) n_gfiles = Math.max(val, this.$refs.gdrivefiles.getSelectedFiles().length);
                if (n_gfiles > 0) this.cost = Math.abs(config.stamina.upload_file);
                if (this.files.length > 0) this.cost = Math.abs(config.stamina.upload_file_ipfs);
            },
            send:function() {
                var files = [];
                for (let file in this.files) {
                    files.push(this.files[file].file);
                }
                var files_connected = [];
                for (let file of this.$refs.gdrivefiles.getSelectedFiles()) {
                    file.gdrive = true;
                    files_connected.push(file);
                }
                var POSITION_DOWNLOAD = 4;
                var POSITION_VIEW = 5;

                var permissionList = [0, 0, 0, 0, 0, 0, 0, 0];
                permissionList[POSITION_VIEW] = 1;
                if (this.permissionViewDownload) {
                    permissionList[POSITION_DOWNLOAD] = 1;
                }
                this.loading = true;
                var temporaryPermissionType = null;
                var temporaryPermissionValue = null;
                if (this.limits && this.temporalPermissions) {
                    temporaryPermissionType = this.temporalPermissions.temporalPermission;
                    temporaryPermissionValue = this.temporalPermissions.temporalValue;
                }

                var givePermissionList= [0, 0, 0, 0, 0, 0, 0, 0];
                if (this.GivePermissionsView) {
                    givePermissionList[POSITION_VIEW] = 1;
                }
                if (this.GivePermissionsDownload) {
                    givePermissionList[POSITION_DOWNLOAD] = 1;
                }

                if(!this.capcha || this.capchaReturn !== "") {
                    FilesRepository.uploadFile(files, this.email, this.emails, this.message, permissionList, temporaryPermissionType, temporaryPermissionValue,givePermissionList,this.capchaReturn, files_connected, this.user_name).then(() => {
                        this.status = 'ok';
                        this.temporalPermissions = null;
                        this.$emit('upload-success');
                    }).catch((error) => {
                        this.errors = (Array.isArray(error.response.data)) ? error.response.data : [error.response.data];
                        this.temporalPermissions = null;
                        this.status = 'error';
                        this.loginButton = error.response.data.login;
                        if (this.loginButton) {
                            this.errorTitle = this.$t("This email is from a registered user.");
                            this.errorDescription = this.$t("Please, login to your account or use a different email.");
                        }
                    })
                }else{
                    this.status = 'error';
                    this.snakeError('You must to complete the capcha first.');
                }

            },
            accepted() {
                if (this.accept) {
                    if (!LocalRepository.has('accepted')) {
                        LocalRepository.set("accepted", true);
                    }
                }
            },
            snakeSuccess(text){
                this.$root.$emit('show-snackbar', {message: text,color: 'success', timeout: 6000 });
            },
            snakeError(text){
                this.$root.$emit('show-snackbar', {message: text,color: 'error', timeout: 6000 });
            },
            clear:function(){
                let query = Object.assign({}, this.$route.query);
                delete query.code;
                this.$router.replace({ query });

                this.permissionViewDownload= false;
                this.GivePermissionsView=false;
                this.GivePermissionsDownload=false;
                this.files=[];
                this.emails=[];
                this.loading=false;
                this.message='';
                this.status='pending';
            },
            tryAgain:function(){
                this.loading=false;
                this.status='pending';
            },
            goRates(){
                window.location = 'https://welicense.io/pricing/';
                //this.$router.push({ name: "rates"})
            },
            goRegister() {
                this.$root.$emit('show-register', {email: this.email});
            },
            goLogin() {
                this.$root.$emit('show-login', {email: this.email});
            },
            testCapcha(){
                //console.log("EM:"+this.email);
                this.loginButton = false;
                this.errorDescription = null;
                this.errorTitle = null;
                if (this.valid_send) {
                    if (!this.capcha) {
                        this.send();
                    } else {
                        this.$refs.recaptcha.execute();
                    }
                }
            },
            verifyCapcha(response){
                this.capchaReturn=response;
                if(this.capchaReturn !== ""){
                    this.send();
                }
            },
            expireCapcha(){
                this.capchaReturn="";
            },
            loadFormData() {
                if (LocalRepository.has('form_data')) {
                    let data = JSON.parse(LocalRepository.get('form_data'));
                    //console.log("Getting: " + LocalRepository.get('form_data'));
                    this.emails = data.emails;
                    this.email = data.email;
                    this.permissionViewDownload = data.permissionDownload;
                    this.GivePermissionsView = data.GivePermissionsView;
                    this.GivePermissionsDownload = data.GivePermissionsDownload;
                    this.temporalPermissions = data.temporalPermissions;
                    this.limits = this.temporalPermissions && (this.temporalPermissions.temporalPermission || this.temporalPermissions.temporalValue);
                    if (this.limits) {
                        this.$nextTick(() => {
                            this.$refs.temporal.loadValues(this.temporalPermissions.temporalPermission,this.temporalPermissions.temporalValue);
                        });
                    }
                    this.message = data.message;
                    LocalRepository.clear('form_data');
                }
            },
        }

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .SharedFilesCard {
        max-width: 1000px;
        margin:auto;
        overflow-y: auto;
        .padding{
            padding: 0px 15px;
        }
    }

    .vue-recaptcha{
        display: inline-block;
    }
    .rc-anchor-normal-footer, .rc-anchor-invisible-text, .rc-anchor {
        display: none;
    }
    .grecaptcha-badge{
        box-shadow: none;
    }
    .checkboxes .v-input{
        margin:0;
    }
</style>
